// src/utils/generateReportJson.js

// Generate JSON Data
export const generateReportJson = (formData, userId, linearityTotalRows, repeatabilityTotalRows, serviceCall, makat, kline, sernum, sern, isUpdate, idToUpdate) => {

    return {
        approverUser: userId || formData.calibratorId,
        idToUpdate: idToUpdate || "",
        isUpdate: isUpdate || false,
        Versions: [
            {
                ThermometerId: formData.thermometerId || "",
                ScaleReportType: formData.reportType,
                ScaleTested: {
                    id: formData.scaleSerialId,
                    InternalID: formData.internalId || "", 
                    PartitionKey: "Scale",
                    Address: formData.address,

                    // New scale accuracy details moved under "ScaleAccuracy"
                    ScaleAccuracy: {
                        WeightUnits: formData.weightUnits,
                        AccuracyClass: formData.accuracyClass,
                        D: formData.dValue,
                        E: formData.eValue,
                        Max: formData.maxValue,
                        Min: formData.minValue,
                        N: formData.nValue
                    }
                },
                WeightSetUsedIdList: [
                    ...(formData.weightSet1 ? [formData.weightSet1.toString()] : []),
                    ...(formData.weightSet2 ? [formData.weightSet2.toString()] : []),
                    ...(formData.useCylinderSet1 ? ["52"] : []),
                    ...(formData.useCylinderSet2 ? ["20"] : [])
                ],
                LinearityTest: formData.linearityTest
                    ? {
                        Rows: Array.from({ length: linearityTotalRows }, (_, i) => ({
                            WeightValue: formData[`linearityWeight${i + 1}`] ? parseFloat(formData[`linearityWeight${i + 1}`]) : null,
                            LoadRead: formData[`linearityLoad${i + 1}`] ? parseFloat(formData[`linearityLoad${i + 1}`]) : null,
                            UnloadRead: formData[`linearityUnload${i + 1}`] ? parseFloat(formData[`linearityUnload${i + 1}`]) : null
                        })).filter(row => row.WeightValue !== null || row.LoadRead !== null || row.UnloadRead !== null)
                    }
                    : null,
                CornersTest: formData.cornersTest
                    ? {
                        Rows: [
                            {
                                WeightValue: formData.cornerWeightValue ? parseFloat(formData.cornerWeightValue) : null,
                                LoadRead: formData.cornerTopLeft ? parseFloat(formData.cornerTopLeft) : null
                            },
                            {
                                WeightValue: formData.cornerWeightValue ? parseFloat(formData.cornerWeightValue) : null,
                                LoadRead: formData.cornerTopRight ? parseFloat(formData.cornerTopRight) : null
                            },
                            {
                                WeightValue: formData.cornerWeightValue ? parseFloat(formData.cornerWeightValue) : null,
                                LoadRead: formData.cornerBottomLeft ? parseFloat(formData.cornerBottomLeft) : null
                            },
                            {
                                WeightValue: formData.cornerWeightValue ? parseFloat(formData.cornerWeightValue) : null,
                                LoadRead: formData.cornerBottomRight ? parseFloat(formData.cornerBottomRight) : null
                            }
                        ]
                    }
                    : null,
                RepeatabilityTest: formData.repeatabilityTest
                    ? {
                        Rows: Array.from({ length: repeatabilityTotalRows }, (_, i) => ({
                            WeightValue: formData[`repeatWeight${i + 1}`] ? parseFloat(formData[`repeatWeight${i + 1}`]) : null,
                            LoadRead: formData[`repeatLoad${i + 1}`] ? parseFloat(formData[`repeatLoad${i + 1}`]) : null,
                            UnloadRead: formData[`repeatUnload${i + 1}`] ? parseFloat(formData[`repeatUnload${i + 1}`]) : null
                        })).filter(row => row.WeightValue !== null || row.LoadRead !== null || row.UnloadRead !== null)
                    }
                    : null,
                    TareTest: formData.tareTest
                    ? {
                        Rows: [
                            {
                                WeightValue: formData.weightValue ? parseFloat(formData.weightValue) : null,
                                LoadRead: formData.loadValue ? parseFloat(formData.loadValue) : null,
                            }
                        ].filter(row => row.WeightValue !== null || row.LoadRead !== null)
                    }
                    : null,
                

                // Add Review Summary
                ReviewSummary: {
                    Visual: formData.visualReview,
                    ResetMechanism: formData.resetMechanism,
                    TareMechanism: formData.tareMechanism,
                    Leveling: formData.leveling,
                    Printing: formData.printing,
                    LoadingPermission: formData.useLoadingPermission ? parseFloat(formData.loadingPermissionValue) : null,
                    UpTo: formData.useCheckUpTo ? parseFloat(formData.checkUpToValue) : null,
                    CalibrationApproval: formData.calibrationApproval
                },

                ContractReview: {
                    IsSymboledPrinting: formData.symbolledPrinting === "Yes"
                },
                Comments: {
                    ItemComment: {
                        EnglishString: formData.comments || "",
                        HebrewString: formData.comments || ""
                    }
                },
                Calibrator: {
                    Id: formData.calibratorId || userId
                },
                CalibrationInfo: {
                    CalibrationDates: {
                        Date: formData.date !== '' ? formData.date : new Date().toISOString(),
                        PeriodInMonths: formData.nextCalibrationMonths
                    }
                },
                EnvironmentInfo: {
                    TemperatureStart: formData.temperatureStart ? parseFloat(formData.temperatureStart) : 0,
                    TemperatureEnd: formData.temperatureEnd ? parseFloat(formData.temperatureEnd) : 0,
                    HumidityStart: formData.humidityStart ? parseFloat(formData.humidityStart) : 0,
                    HumidityEnd: formData.humidityEnd ? parseFloat(formData.humidityEnd) : 0
                },
                PriorityInfo: {
                    ServiceCall: serviceCall,
                    Makat: makat,
                    Kline: kline,
                    Sernum: sernum,
                    Sern: sern
                }
            }
        ]
    };
};
